module.exports = __webpack_public_path__ + "img/040.c3e2ee67.png";